import { createAsyncThunk } from '@reduxjs/toolkit'
import okHttp from '@helper/okHttp'
import { user, order, getTypePrefix  } from '@/api'

/**
 * 客户基础信息
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const getUserDetailAction = createAsyncThunk(
    getTypePrefix(user.getUserDetail),
    async (params) => await okHttp(user.getUserDetail, {
        method: 'GET',
	    params
    })
)

/**
 * 客户等级积分
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
// export const getMemberBonusFlowAction = createAsyncThunk(
//     getTypePrefix(user.getMemberBonusFlow),
//     async (data) => await okHttp(user.getMemberBonusFlow, {
//         method: 'POST',
//         data
//     })
// )

/**
 * 交易记录
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const getOrderListAction = createAsyncThunk(
    getTypePrefix(`${order.getOrderListUrl}_by_user`),
    async (params) => await okHttp(order.getOrderListUrl, {
        method: 'POST',
        ...params
    })
)

/**
 * 收货地址
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const getReceiveAddressAction = createAsyncThunk(
    getTypePrefix(user.getReceiveAddress),
    async (params) => await okHttp(user.getReceiveAddress, {
        method: 'GET',
	    params
    })
)

/**
 * 登录日志
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
// export const getLoginLogListAction = createAsyncThunk(
//     getTypePrefix(user.getLoginLogList),
//     async (data) => await okHttp(user.getLoginLogList, {
//         method: 'POST',
//         data
//     })
// )
